<template>
  <section class="error-container">
    <div class="error-content">
      <h1 class="error-code">404</h1>
      <h2 class="error-message">¡Tu enlace ha caducado!</h2>
      <p class="error-description">
        Parece que este enlace ya no está disponible o ha expirado.  
      </p>
      
    </div>
  </section>
</template>

<script>
import { destruirAlerta } from "../../utils/Utils";

export default {
  name: "SesionCaducada",
  created() {
    destruirAlerta();
  },
  methods: {
    volverInicio() {
      this.$router.push({ name: "Login" });
    },
  },
};
</script>

<style lang="scss" scoped>
.error-container {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 2rem;
  color: #fff;

    /* 🎨 Fondo tipo galaxia azul con profundidad */
  background: radial-gradient(circle at 75% -50%, #00000090 30%, #ffffff00 40%),
    linear-gradient(-40deg, #ff000000, #080c34 60%, #0000ff00),
    radial-gradient(circle at 55% 150%, #3094bc 40%, #00000010 70%),
    radial-gradient(at 0% 0%, #206ca4 5%, #00000000 40%),
    linear-gradient(to bottom, #080c34 0%, #184c7c 100%);
  background-attachment: fixed;
  overflow: hidden;
}

.error-content {
  max-width: 600px;
  animation: fadeIn 0.8s ease-out;
}

.error-code {
  font-size: 10rem;
  font-weight: 900;
  margin: 0;
  line-height: 1;
  text-shadow: 4px 4px 12px rgba(0, 0, 0, 0.3);
  letter-spacing: -4px;
  background: linear-gradient(90deg, #fff, #c4b5fd);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: float 2.5s ease-in-out infinite;
}

.error-message {
  font-size: 1.8rem;
  font-weight: 600;
  margin: 1rem 0;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: white;
}

.error-description {
  color: rgba(255, 255, 255, 0.8);
  font-size: 1rem;
  margin-bottom: 2rem;
  line-height: 1.5;
}

.error-btn {
  background: #fff;
  color: #4f46e5;
  font-weight: 600;
  padding: 0.8rem 1.8rem;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.error-btn:hover {
  background: #f3f4f6;
  transform: translateY(-2px);
}

/* Animaciones */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

/* Responsividad */
@media (max-width: 768px) {
  .error-code {
    font-size: 6rem;
  }

  .error-message {
    font-size: 1.4rem;
  }

  .error-description {
    font-size: 0.9rem;
  }
}
</style>
